<!-- 审批类型 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-management"></i> 审批类型</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="类型名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入类型名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="创建人" prop="creatorName"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteDepartment(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        @close="resetForm"
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑类型' : '新增类型'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentDepartment"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="currentDepartment.name"
              placeholder="请输入类型名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveDepartment">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  applicationType,
  applicationTypeDetail,
  applicationTypeEdit,
  applicationTypeDelete,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        name: "", // 查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      tableData: [],
      dialogVisible: false,
      currentDepartment: {
        name: "",
      },
      isEdit: false,
      rules: {
        name: [
          { required: true, message: "部门名称是必填项", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    handleQuery(page) {
      const { name } = this.queryParams;
      this.currentPage = page || 1;
      applicationType({
        name,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.handleQuery(1);
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentDepartment = { name: "" };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.currentDepartment = { ...row };
      this.dialogVisible = true;
    },
    saveDepartment() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {};
          if (this.isEdit) {
            params.id = this.currentDepartment.id; // 编辑时传 id
          }
          params.name = this.currentDepartment.name;

          applicationTypeEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },

    deleteDepartment(row) {
      this.$confirm("确定删除此审批类型?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          applicationTypeDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
